import React, { useState, useEffect, useMemo } from "react";
import shared from "../../styles/UserProfileCommon.module.scss";
import styles from "../../styles/admanager/UserAdManagement.module.scss";
import { isMobileDevice } from "../../utils/browserUtils";
import { useDispatch, useSelector } from "react-redux";
import { fetchAdPaymentTransactions } from "../../actions/monetization";
import GenericTable from "../helpers/genericTable";
import { getPaymentTransactions } from "../../selectors/monetizationSelector";
import selectCurrentState from "../../selectors/selectCurrentState";
import { TRANSACTIONS_COLUMNS } from "../../textContent/tableColumns";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons/faChevronUp";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons/faChevronDown";
import UserRevShareDetails from "./UserRevShareDetails";
import UserTotalEarnings from "./UserTotalEarnings";
import UserEarningsReport from "./UserEarningsReport"
import Spinner from "../../components/Spinner";
import { WorkState } from "../../reducers/models";
import UserMetricByDay from "./UserMetricByDay";

export default function UserAdEarnings(props) {
  const dispatch = useDispatch();
  const transactions = useSelector(getPaymentTransactions);
  const { workState } = useSelector(selectCurrentState);

  const isLoading = workState.transactionsFetch === WorkState.Loading;
  const [errorMessage, setErrorMessage] = useState(false);

  useEffect(() => {
    dispatch(fetchAdPaymentTransactions());
  }, [dispatch]);

  useEffect(() => {
    if (workState.transactionsFetch === WorkState.Success) {
      setErrorMessage("");
    } else if (workState.transactionsFetch === WorkState.Error) {
      //TODO: should we set error message? or use toast
      setErrorMessage(
        "There was a problem fetching your transactions history."
      );
    }
  }, [workState.transactionsFetch]);

  const columns = useMemo(
    () => [
      {
        Header: " ",
        columns: TRANSACTIONS_COLUMNS,
      },
      {
        // Build our expander column
        id: "expander", // Make sure it has an ID
        Header: ({ getToggleAllRowsExpandedProps, isAllRowsExpanded }) => (
          <span {...getToggleAllRowsExpandedProps()}>
            {/* {isAllRowsExpanded ? (
              <FontAwesomeIcon icon={faChevronUp} />
            ) : (
              <FontAwesomeIcon icon={faChevronDown} />
            )} */}
          </span>
        ),
        Cell: ({ row }) =>
          // Use the row.canExpand and row.getToggleRowExpandedProps prop getter
          // to build the toggle for expanding a row
          row.canExpand ? (
            <span
              {...row.getToggleRowExpandedProps({
                style: {
                  // We can even use the row.depth property
                  // and paddingLeft to indicate the depth
                  // of the row
                  paddingLeft: `${row.depth * 2}rem`,
                },
              })}
            >
              {isMobileDevice() ? (
                <div className={styles.showHideBundle}>
                  {row.isExpanded ? `Hide Bundles` : `Show Bundles`}
                </div>
              ) : (
                <div>
                  {row.isExpanded ? (
                    <FontAwesomeIcon icon={faChevronUp} />
                  ) : (
                    <FontAwesomeIcon icon={faChevronDown} />
                  )}
                </div>
              )}
            </span>
          ) : null,
      },
    ],
    []
  );

  const data = useMemo(() => transactions, [transactions]);

  const tablePaginationProps = {
    showSkipToEnd: false,
    showSkipToBeginning: false,
    showPageSizeDropdown: false,
    showGoToPage: false,
    pageItem: 10,
    rowHeight: 51,
  };
  const rowClickCallback = (row) => {
    console.log("rowClickCallback", row);
  };

  const spinnerStyle = {
    height: "50px",
    width: "50px",
  };

  const renderTable = () => {
    if (isLoading) {
      return (
        <div className={shared.spinnerWrapper}>
          <Spinner isLoading={isLoading} spinnerStyle={spinnerStyle} />
        </div>
      );
    }

    if (
      workState.projectsFetch === WorkState.None &&
      transactions.length === 0
    ) {
      return (
        <div className={styles.errorContainer}>
          <p>There is no current transaction history</p>
        </div>
      );
    }
    return (
      <GenericTable
        data={data}
        columns={columns}
        rowClickCallback={rowClickCallback}
        tablePaginationProps={tablePaginationProps}
        scrollToOption={false}
      />
    );
  };


  return (
    <div className={styles.userAdManagementWrapper}>
      <h2>My Earnings</h2>
      <div className={shared.subHeader}>
        <UserRevShareDetails />
        <hr className={shared.dividerLine} />
        <h2>Earnings to be Paid</h2>
        <UserTotalEarnings props={props} />
      </div>
      <hr className={shared.dividerLine} />
      <div>
        <h2>Metrics by Day</h2>
        <UserMetricByDay />
      </div>
      <hr className={shared.dividerLine} />
     <div>
        <UserEarningsReport/>
      </div>
      <hr className={shared.dividerLine} />
      <h2>Transaction History</h2>
      {errorMessage ? (
        <div className={styles.errorContainer}>
          <p>{errorMessage}</p>
        </div>
      ) : (
        <div>{renderTable()}</div>
      )}
    </div>
  );
}
